/**
 * @description 網投會員狀態 (enum)
 */
export enum MemberActiveEnum {
  /** 啟用 */
  EN = 'EN',
  /** 未啟用 */
  NA = 'NA',
  /** 鎖定 */
  LK = 'LK',
  /** 凍結 (超過五年未投保) */
  FZ = 'FZ',
  /** 註銷 */
  DA = 'DA'
}
